import * as React from "react";
import { useTranslation } from "react-i18next";
import CommonContainer from "../../../components/common/container/CommonContainer";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import useSnackbarAlert from '../../../utils/snackbarHandlers';
import { ViewAdDetails } from "../../../components";
import { LinearProgress } from "@mui/material";

const initialData = {
  productTitle: "",
  productPriceDescription: "",
  adLocation: "",
  image: "",
};

const ViewAdvertisement: React.FC = () => {
  const { t } = useTranslation('translation');
  const { id } = useParams();
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
  const [adData, setAdData] = React.useState<any>(initialData);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    setLoading(true);
    axios.get(`${apiBaseURL}/api/advertisement/getParticularAdvertisementDetails?id=${id}`).then((res: any) => {
      if (res?.status === 200) {
        setAdData(res?.data?.advertisementInformation)
      } else setAdData({})
    })
      .catch((err: any) => showErrorMessage(err))
      .finally(() => setLoading(false))
  }, [])

  return (
    <CommonContainer title={t("viewAdPageTitle")} description={t("viewAdPageDescription")}>
      {loading ? <LinearProgress /> : <ViewAdDetails adData={adData} />}
    </CommonContainer>
  );
};

export default ViewAdvertisement;
